import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeader({ eyebrow, title, desc, linkTo, linkLabel }: SectionHeaderProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-sm font-bold text-primary-600">
            <i className="ri-sparkling-2-line" aria-hidden="true" />
            {eyebrow}
          </span>
        )}
        <h2 className="text-2xl text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm font-bold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {linkLabel || '查看全部'}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}